import React, { useCallback, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Modal, Text } from '@maui/elements'
import { usePOVEndDate } from '../store/auth'
import { openModal } from '../store/appModal/actions'

const CountDown = ({ endDate, openModal }) => {
  const daysLeft = useMemo(() => {
    if (endDate === undefined) return

    const today = new Date()
    const formattedEndDate = new Date(endDate)
    // Add one because the end date is inclusive
    const daysLeft = (formattedEndDate.getTime() - today.getTime()) / (1000 * 3600 * 24) + 1
    return Math.ceil(daysLeft)
  }, [endDate])

  return (daysLeft > 0) && (
    <Button
      userSelect='none'
      cursor='pointer'
      backgroundColor='colorActionPrimary'
      marginLeft='spaceGapMedium'
      display={['none', 'none', 'none', 'block']}
      borderWidth='1px'
      borderStyle='solid'
      borderColor='colorTextEmphasis'
      fontFamily='textPillFontFamily'
      fontSize='textPillFontSize'
      color='colorTextReverse'
      fontWeight='textPillFontWeight'
      paddingLeft='8px'
      paddingRight='8px'
      paddingTop='0'
      paddingBottom='0'
      borderRadius='radiusLarge'
      onClick={openModal}
    >
      {'Free Trial: '}
      <Text as='span' fontSize='10px' fontWeight='fontWeightBold'>
        { daysLeft } { daysLeft > 1 ? 'days' : 'day'} remaining
      </Text>
    </Button>
  )
}

export default function TrialTimer({ setFeaturesVisible }) {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const povObj = usePOVEndDate()

  const requestUpgradeModal = useCallback((sku) => {
    setIsOpen(false)
    dispatch(openModal('UpgradeModal', { sku }))
  }, [dispatch])

  const endDate = useMemo(() => {
    if (!povObj) return undefined
    if (!povObj.end_date) {
      const today = new Date()
      return today.getTime() + (14 * 24 * 60 * 60 * 1000)
    }
    setFeaturesVisible(true)
    return povObj.end_date
  }, [povObj, setFeaturesVisible])

  return (
    <>
      <CountDown endDate={endDate} openModal={() => setIsOpen(true)} />
      <Modal isOpen={isOpen} size="medium">
        <Modal.Header onClose={() => setIsOpen(false)}>
          <Modal.Title>Free Trial</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          We hope you are enjoying your complementary Security Operations subscription experience with Mandiant Threat Intelligence. Please click Upgrade to purchase a subscription before the end of your trial period to maintain access to Mandiant premium Threat Intel content.
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' marginRight='spaceGapMedium' onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button onClick={() => requestUpgradeModal()}>
            Upgrade
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
